export const TARIFF_TYPES = {
  ESSENTIAL: 'essential',
  PREMIUM: 'premium',
} as const

export type TariffType = (typeof TARIFF_TYPES)[keyof typeof TARIFF_TYPES]

export const FEATURES = {
  // Available to all plans
  DASHBOARD: 'dashboard',
  PROFIT_CALCULATOR: 'profit_calculator',
  REVIEWS_MANAGEMENT: 'reviews_management',
  REPRICER_BASIC: 'repricer_basic',
  SUPPORT_CHAT: 'support_chat',
  SLOT_SEARCH: 'slot_search',
  // Premium-only features
  AUTO_BOOKING: 'auto_booking',
  REPRICER_COMPETITORS: 'repricer_competitors',
  AI_CHAT: 'ai_chat',
  MULTI_STORE: 'multi_store',
  SUPPLIER_DATABASE: 'supplier_database',
  PRIORITY_SUPPORT: 'priority_support',
} as const

export type Feature = (typeof FEATURES)[keyof typeof FEATURES]

// Features available for each tariff
export const TARIFF_FEATURES: Record<TariffType, Feature[]> = {
  [TARIFF_TYPES.ESSENTIAL]: [
    FEATURES.DASHBOARD,
    FEATURES.PROFIT_CALCULATOR,
    FEATURES.REVIEWS_MANAGEMENT,
    FEATURES.REPRICER_BASIC,
    FEATURES.SUPPORT_CHAT,
    FEATURES.SLOT_SEARCH,
  ],
  [TARIFF_TYPES.PREMIUM]: [
    FEATURES.DASHBOARD,
    FEATURES.PROFIT_CALCULATOR,
    FEATURES.REVIEWS_MANAGEMENT,
    FEATURES.REPRICER_BASIC,
    FEATURES.SUPPORT_CHAT,
    FEATURES.SLOT_SEARCH,
    FEATURES.AUTO_BOOKING,
    FEATURES.REPRICER_COMPETITORS,
    FEATURES.AI_CHAT,
    FEATURES.MULTI_STORE,
    FEATURES.SUPPLIER_DATABASE,
    FEATURES.PRIORITY_SUPPORT,
  ],
}

// List of premium-only features for easy reference
export const PREMIUM_ONLY_FEATURES: Feature[] = [
  FEATURES.AUTO_BOOKING,
  FEATURES.REPRICER_COMPETITORS,
  FEATURES.AI_CHAT,
  FEATURES.MULTI_STORE,
  FEATURES.SUPPLIER_DATABASE,
  FEATURES.PRIORITY_SUPPORT,
]

// Feature display names (for i18n keys)
export const FEATURE_I18N_KEYS: Record<Feature, string> = {
  [FEATURES.DASHBOARD]: 'dashboard',
  [FEATURES.PROFIT_CALCULATOR]: 'profit_calculator',
  [FEATURES.REVIEWS_MANAGEMENT]: 'reviews_management',
  [FEATURES.REPRICER_BASIC]: 'repacker',
  [FEATURES.SUPPORT_CHAT]: 'tariff_feature_support_chat',
  [FEATURES.SLOT_SEARCH]: 'slot_search',
  [FEATURES.AUTO_BOOKING]: 'auto_booking',
  [FEATURES.REPRICER_COMPETITORS]: 'tariff_feature_repricer_full',
  [FEATURES.AI_CHAT]: 'tariff_feature_ai_chat',
  [FEATURES.MULTI_STORE]: 'tariff_feature_multi_store',
  [FEATURES.SUPPLIER_DATABASE]: 'tariff_feature_supplier_database',
  [FEATURES.PRIORITY_SUPPORT]: 'tariff_feature_priority_support',
}
